import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;

  .content {
    display: flex;
    justify-content: space-between;
    grid-gap: 60px;
  }

  p.description {
    color: var(--color-text-muted);
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin: 20px 0;
  }

  .buttonContainer {
    width: 300px;
    max-width: 100%;
    display: flex;
    grid-gap: 10px;
    position: absolute;
    bottom: 30px;
  }
`;
